/**
 * Builds the Community Development monthly report URL from form state.
 *
 * @param {NodeList|Array} checkboxes - jurisdiction checkbox elements
 * @returns {string} the full report URL with query params
 */
export function buildCdMonthlyReportUrl(checkboxes) {
    const reportYear = document.getElementById("year")
    const reportMonth = document.getElementById("month")
    if (!reportYear || !reportMonth) { return '/reports/cd/monthly' }
    let url = '/reports/cd/monthly?year=' + reportYear.value + '&month=' + reportMonth.value

    const allCheckboxes = Array.from(checkboxes)
    if (allCheckboxes.length > 0) {
        const selected = allCheckboxes.filter(cb => cb.checked).map(cb => cb.value)
        if (selected.length > 0 && selected.length < allCheckboxes.length) {
            url += '&jurisdiction_id=' + encodeURIComponent(selected.join(','))
        }
    }

    return url
}
